module.exports = __webpack_public_path__ + "img/mobile-menu-huay.9b01d7e5.webp";